import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IStampsOfferTrend } from '@/shared/model/stamps-offer-trend.model';

const baseApiUrl = 'api/stamps-offer-trends';
const baseSearchApiUrl = 'api/_search/stamps-offer-trends?query=';

export default class StampsOfferTrendService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IStampsOfferTrend> {
    return new Promise<IStampsOfferTrend>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IStampsOfferTrend): Promise<IStampsOfferTrend> {
    return new Promise<IStampsOfferTrend>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IStampsOfferTrend): Promise<IStampsOfferTrend> {
    return new Promise<IStampsOfferTrend>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
